import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

import UpdateModalComponent from '../components/update-modal/update-modal.jsx';
import {openUpdateModal, closeUpdateModal} from '../reducers/modals';
import {checkForUpdate} from '../lib/version-check';

class UpdateModal extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleClose',
            'handleViewDetails'
        ]);
        this.state = {
            updateInfo: null
        };
    }
    componentDidMount () {
        // 延迟检查，避免影响首屏加载性能
        setTimeout(() => {
            checkForUpdate().then(info => {
                if (info) {
                    this.setState({updateInfo: info});
                    this.props.onOpenUpdateModal();
                }
            });
        }, 3000);
    }
    handleClose () {
        this.props.onCloseUpdateModal();
    }
    handleViewDetails () {
        if (this.state.updateInfo && this.state.updateInfo.releaseUrl) {
            window.open(this.state.updateInfo.releaseUrl, '_blank', 'noopener');
        }
        this.props.onCloseUpdateModal();
    }
    render () {
        if (!this.props.visible || !this.state.updateInfo) return null;
        return (
            <UpdateModalComponent
                updateInfo={this.state.updateInfo}
                onRequestClose={this.handleClose}
                onViewDetails={this.handleViewDetails}
            />
        );
    }
}

UpdateModal.propTypes = {
    visible: PropTypes.bool,
    onOpenUpdateModal: PropTypes.func,
    onCloseUpdateModal: PropTypes.func
};

const mapStateToProps = state => ({
    visible: state.scratchGui.modals.updateModal
});

const mapDispatchToProps = dispatch => ({
    onOpenUpdateModal: () => dispatch(openUpdateModal()),
    onCloseUpdateModal: () => dispatch(closeUpdateModal())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UpdateModal);
